import GridBanners from "./modules/_gridBanners";

document.addEventListener("DOMContentLoaded", function () {
	const initGridBanners = new GridBanners();
});